/** Shared by every form control (TextField, Select) so a text input, a textarea, and a
 * native select all look like one family — matches registry-editor.html's joint
 * `input,textarea,select { … }` rule rather than each control inventing its own shape.
 * Focus = border-color change + a soft tinted glow, not a hard outline ring — matches
 * that file's `box-shadow: 0 0 0 3px var(--accent-bg)` focus treatment. */
export const FIELD_STYLES =
  "w-full rounded border border-line-mid bg-bg px-2.5 py-2 text-[13.5px] text-text outline-none " +
  "focus:border-accent focus:bg-surface focus:ring-[3px] focus:ring-accent-bg";
